module.exports = __webpack_public_path__ + "fonts/GothamSSm-Light_Web.b0e7982.woff2";